import { unstable_useCompatFactory } from '@formily/reactive-react';
import { uid } from '@formily/shared';
import { useForm } from './useForm';
export var useFormEffects = function (effects) {
    var form = useForm();
    unstable_useCompatFactory(function () {
        var id = uid();
        form.addEffects(id, effects);
        return {
            dispose: function () {
                form.removeEffects(id);
            },
        };
    });
};
//# sourceMappingURL=useFormEffects.js.map